import styled from "styled-components";

export const Content = styled.div`
     padding: 20px;
    position: relative;
    width: 100%;
    min-height: 200px;
    max-height: 600px;
    background-color: ${({ theme }) => theme.colors.secondary10};
    border-radius: 8px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    margin-top: 30px;
    margin-bottom: 30px;
    .header-conf {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 18px;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.secondary70};
      width: 100%;
      span {
        font-weight: 500;
        color: ${({ theme }) => theme.colors.secondary100};
        display: flex;
        align-items: center;
        svg {
          margin-left: 5px;
        }
      }
    }
    .main-content {
      margin-top: 20px;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 20px;
      align-items: center;
      justify-content: center;
      h2{
        font-size: 18px;
        color: ${({ theme }) => theme.colors.secondary70};
      }
    }
`;
